import { render, staticRenderFns } from "./QrCodeQuiz.vue?vue&type=template&id=7b4f5f36&scoped=true"
import script from "./QrCodeQuiz.vue?vue&type=script&lang=js"
export * from "./QrCodeQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4f5f36",
  null
  
)

export default component.exports